import { PaginationSort, QuoteFilterInput } from '../gql/graphql';
import { getPaginatedNodes, toPagination } from './utils';

import { graphql } from '../gql';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

export const GET_QUOTES_PAGE = graphql(`
  query getQuotesPage(
    $pagination: PaginationRequest
    $sort: PaginationSort
    $filters: QuoteFilterInput
  ) {
    quotes(filters: $filters, sort: $sort, pagination: $pagination) {
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
        pageNumber
        pageSize
      }
      edges {
        node {
          uuid
          status
          referenceId
          endorsementImpact
          createdAt
          updatedAt
          type
          name
          order
          quotedPremium
          selectedQuotedPremium
          limit
          retention
          ratedPremium
          technicalPremium
          modifiedCoveragePremium
          isObsolete
          obsoleteAt
        }
      }
    }
  }
`);
export interface IUseQuotesQueryArg {
  pageNumber: number;
  pageSize: number;
  filters?: QuoteFilterInput;
  sort?: PaginationSort;
}
export function useGetQuotesPageQuery({
  pageNumber,
  pageSize,
  filters,
  sort,
}: IUseQuotesQueryArg) {
  const { loading, error, data } = useQuery(GET_QUOTES_PAGE, {
    variables: {
      pagination: toPagination(pageNumber, pageSize),
      sort,
      filters: {
        ...filters,
      },
    },
    fetchPolicy: 'no-cache',
  });

  const { quotes, totalQuotes } = useMemo(() => {
    return {
      quotes: getPaginatedNodes(data?.quotes),
      totalQuotes: data?.quotes.pageInfo?.totalResults,
    };
  }, [data]);

  return {
    error,
    loading,
    data,
    quotes,
    totalQuotes,
  };
}
